var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({ once: true, callback: _vm.visibilityChange }),expression:"{ once: true, callback: visibilityChange }"}],staticClass:"candy-planets"},[(_vm.visible)?[_c('float',{staticClass:"candy-planets__float"},[_c('candy-planets-video')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }